import Color from '../color.es6'
import Ren from '../ren-shape.es6'
import Element from './element.es6'

export default class Generic extends Element {
  get radius () {
    return 20 / this.absoluteSizeScale
  }

  setDefaultShapes () {
    const { absoluteSizeScale, radius } = this
    this.shapes = [
      new Ren.Circle({
        name: 'circle',
        x: 0,
        y: 0,
        radius,
        strokeWidth: 1 / absoluteSizeScale,
        fill: Color.white
      })
    ]
  }

  applyStatusOnShapes () {
  }
}
